// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38U67","select":"styles_select__1aRRs"};